import { render, staticRenderFns } from "./ProfileButtons.vue?vue&type=template&id=72657bdb&"
import script from "./ProfileButtons.vue?vue&type=script&lang=js&"
export * from "./ProfileButtons.vue?vue&type=script&lang=js&"
import style0 from "./ProfileButtons.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports